document.addEventListener("DOMContentLoaded", function() {

    var url = window.location.href.toLowerCase();

    // siamo su una pagina prodotto?
    if (url.indexOf('/products/') !== -1) {
        // l'URL NON contiene fw25
        if (url.indexOf('fw25') === -1 && url.indexOf('ss26') === -1) {

            var gallery = document.querySelector('product-media-gallery');
            if (gallery) {
                var p = document.createElement('p');
                p.className = 'extra-off';
                p.textContent = 'EXTRA 15%';
                gallery.prepend(p);
            }
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {

  // siamo su una pagina prodotto?
  if (window.location.pathname.indexOf('/products/') !== -1) {

    var productInfo = document.querySelector('product-info');

    // controlliamo il metafield coming soon
    if (productInfo && productInfo.dataset.comingSoon === 'SI') {

      //var gallery = document.querySelector('product-media-gallery');
      var gallery = document.querySelector('.product-image-slideshow-item:first-child');
      if (!gallery) return;

      var text = 'PRESTO IN ARRIVO'; // fallback IT

      var path = window.location.pathname.toLowerCase();

      if (path.indexOf('/en/') !== -1) {
        text = 'COMING SOON';
      } else if (path.indexOf('/fr/') !== -1) {
        text = 'BIENTÔT DISPONIBLE';
      }

      var p = document.createElement('p');
      p.className = 'coming-soon';
      p.textContent = text;

      gallery.prepend(p);
    }
  }
});


document.querySelectorAll('.slideshow-item.pos-relative').forEach(item => {
    item.addEventListener('click', function (e) {

        const link = this.querySelector('a');
        if (link && link.href) {
            window.location.href = link.href;
        }

    });
});

document.querySelectorAll('.media-grid-item.media-hover').forEach(item => {
    item.addEventListener('click', function (e) {

        const link = this.querySelector('a');
        if (link && link.href) {
            window.location.href = link.href;
        }

    });
});


document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(
    "#shopify-section-template--26769152934219__video_bPNhiz, " +
    "#shopify-section-template--26769152934219__video_emNfkp, " +
    "#shopify-section-template--26769152934219__video_t8PG6p"
  );

  if (!elements.length) return;

  elements.forEach(function (el) {
    el.addEventListener("click", function () {
      const path = window.location.pathname.toLowerCase();

      let lang = "";

      if (path.startsWith("/en")) {
        lang = "/en";
      } else if (path.startsWith("/fr")) {
        lang = "/fr";
      }

      const targetUrl = `${window.location.origin}${lang}/collections/ss26`;
      window.location.href = targetUrl;
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector("#shopify-section-template--26769152934219__shop_the_look_q6BLHY");
  if (!el) return;

  el.addEventListener("click", function () {
    const path = window.location.pathname;

    let lang = "";

    // Se il path inizia con /en o /fr
    if (path.startsWith("/en")) {
      lang = "/en";
    } else if (path.startsWith("/fr")) {
      lang = "/fr";
    }

    const targetUrl = `${window.location.origin}${lang}/collections/ss26`;
    window.location.href = targetUrl;
  });
});


/* Cambio icona vanchat */
document.addEventListener("DOMContentLoaded", function () {

  const interval = setInterval(() => {
    const img = document.querySelector('div#vanchat-root .animation-icon img');

    if (img) {
      img.src = 'https://cdn.shopify.com/s/files/1/0766/8436/2059/files/icona-chat.png?v=1778792859';
      clearInterval(interval);
    }
  }, 500);

});

document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector("#shopify-section-template--26769152934219__shop_the_look_m8GxCt");
  if (!el) return;

  el.addEventListener("click", function () {
    const path = window.location.pathname;

    let lang = "";

    // Se il path inizia con /en o /fr
    if (path.startsWith("/en")) {
      lang = "/en";
    } else if (path.startsWith("/fr")) {
      lang = "/fr";
    }

    const targetUrl = `${window.location.origin}${lang}/collections/ss26`;
    window.location.href = targetUrl;
  });
});

document.querySelectorAll('.detail-list li').forEach(li => {
  if (!li.textContent.trim()) {
    li.style.display = 'none';
  }
});

document.addEventListener("click", function (e) {
  const trigger = e.target.closest("quick-view a, quick-view-drawer .product-variant-item, div[data-product-hotspot]");
  if (!trigger) return;

  setTimeout(() => {
    console.log("🔄 QuickView aperta → aggiorno label swatch");

    const productInfo = document.querySelector(".quickview-popup product-info");
    if (!productInfo) return;

    let raw = productInfo.getAttribute("data-swatch-images");
    if (!raw) return;

    // Sostituisco &quot; con "
    raw = raw.replace(/&quot;/g, '"').trim();

    let swatchData;
    try {
      swatchData = JSON.parse(raw);
    } catch (err) {
      console.error("❌ JSON esterno non valido", raw, err);
      return;
    }

    console.log("🟦 JSON ESTERNO PARSED:", swatchData);

    // Il valore "Colore" è ANCORA una STRINGA JSON → va parsata
    Object.keys(swatchData).forEach(key => {
      if (typeof swatchData[key] === "string") {
        try {
          swatchData[key] = JSON.parse(swatchData[key]);
        } catch (innerErr) {
          console.error("❌ JSON interno non valido per", key, innerErr);
        }
      }
    });

    console.log("🟩 JSON FINALE:", swatchData);

    const labels = productInfo.querySelectorAll("label.variant-label");
    labels.forEach(label => {
      const input = document.querySelector(`#${label.getAttribute("for")}`);
      if (!input) return;

      let optionName = input.getAttribute("name");
      const optionValue = input.getAttribute("value");

      // 🔥 NORMALIZZAZIONE MULTILINGUA
      const normalizedName = optionName.toLowerCase();
      if (
        normalizedName === "colore" ||
        normalizedName === "color" ||
        normalizedName === "couleur"
      ) {
        optionName = "Colore";
      }

      if (swatchData[optionName] && swatchData[optionName][optionValue]) {
        let imgUrl = swatchData[optionName][optionValue];

        if (!imgUrl.startsWith("//")) {
          imgUrl =
            "//ermannofirenze.com/cdn/shop/" +
            imgUrl.replace(/^files\//, "files/") +
            "?width=246";
        }

        label.style.backgroundImage = `url(${imgUrl})`;
        label.style.backgroundPosition = "center";
        label.style.backgroundSize = "cover";

        console.log(`✅ Swatch impostato: ${optionName}=${optionValue}`, imgUrl);
      } else {
        console.log(`⚠️ Nessuna immagine per ${optionName}=${optionValue}`);
      }
    });


  }, 600); // 600ms → abbastanza per assicurare caricamento quickview
});

/* point carosello mobile */
document.addEventListener('DOMContentLoaded', function () {
  var tracks = document.querySelectorAll('.product-card-mobile-swipe');

  tracks.forEach(function (track) {
    var wrapper = track.closest('.product-card-image, .product-image');
    var dotsContainer = wrapper ? wrapper.querySelector('[data-card-dots]') : null;
    if (!dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('[data-dot]');

    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }, { passive: true });
  });
});

/* nascondo chat footer */
document.addEventListener('DOMContentLoaded', function () {
  var footer = document.querySelector('footer');
  var button = document.querySelector('button.vanus-custom.vc-animation-container');

  if (!footer || !button) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        button.classList.toggle('footer-visible', entry.isIntersecting);
      });
    },
    {
      root: null,
      threshold: 0
    }
  );

  observer.observe(footer);
});